// frontend/src/services/attendanceService.js
import api from './api';

const ATTENDANCE_API_PATH = '/attendance';

/**
 * Fetches attendance records for a specific date and subject.
 * @param {string} date - The date in 'YYYY-MM-DD' format.
 * @param {number} subjectId - The ID of the subject.
 */
export const getAttendanceByDateAndSubject = async (date, subjectId, classId, mode) => { // <-- Add mode
    try {
        const response = await api.get(ATTENDANCE_API_PATH, {
            params: { date, subject_id: subjectId, class_id: classId, mode } // <-- Send mode
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching attendance for date ${date}:`, error);
        throw error;
    }
};


/**
 * Saves attendance records for a specific date, class, and subject.
 * @param {string} date - The date in 'YYYY-MM-DD' format.
 * @param {number} subjectId - The ID of the subject.
 * @param {number} classId - The ID of the class.
 * @param {Array} attendanceRecords - An array of { student_id, status, subject_id, part_of_day } objects.
 * @param {string} mode - The mode of attendance (e.g., 'period', 'daily', 'fnan').
 */
export const saveAttendance = async (date, subjectId, classId, attendanceRecords, mode) => {
    try {
        const endpoint = `${ATTENDANCE_API_PATH}/${mode}`; // Adjust endpoint based on mode
        const payload = {
            date,
            class_id: classId,
            attendanceRecords
        };

        if (mode === 'period') {
            payload.subject_id = subjectId;
        } else if (mode === 'fnan') {
            payload.fnRecords = attendanceRecords.filter(record => record.part_of_day === 'FN');
            payload.anRecords = attendanceRecords.filter(record => record.part_of_day === 'AN');
        }

        const response = await api.post(endpoint, payload);
        return response.data;
    } catch (error) {
        console.error('Error saving attendance:', error);
        throw error;
    }
};

export const getAttendanceStats = async (studentId) => {
    try {
        const response = await api.get(`${ATTENDANCE_API_PATH}/stats/${studentId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching attendance stats for student ${studentId}:`, error);
        throw error;
    }
}

export const getAttendanceReport = async (studentId, params) => {
    try {
        const response = await api.get(`${ATTENDANCE_API_PATH}/report/${studentId}`, { params });
        return response.data;
    } catch (error) {
        console.error(`Error fetching attendance report for student ${studentId}:`, error);
        throw error;
    }
};

// Get class attendance stats with flexible parameters
export const getClassAttendanceStats = async (classId, params = {}) => {
    try {
        const response = await api.get(`${ATTENDANCE_API_PATH}/stats/class`, { 
            params: { class_id: classId, ...params } 
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching class attendance stats for class ${classId}:`, error);
        throw error;
    }
};

// Get student attendance report data with flexible parameters
export const getStudentAttendanceReportData = async (studentId, params = {}) => {
    try {
        const response = await api.get(`${ATTENDANCE_API_PATH}/report/data`, { 
            params: { student_id: studentId, ...params } 
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching student attendance report for student ${studentId}:`, error);
        throw error;
    }
};
